<template>
  <div class="section-title-col col-grid-6">
    <h2>{{titleName}}</h2>
    <div class="section-count" v-if="titleCounter">
      {{ titleCounter }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'SectionTitle',
  props: {
    titleName: String,
    titleCounter: Number
  },
  computed: {
  }
}

</script>

<style scoped lang="scss">
@import 'uc/_variables';

  .section-title {
      padding: 22px 0;
  }
  h2 {
      display: inline-block;
      font-size: 28px;
      font-weight: 300;
      color: #000;
      vertical-align: middle;
      margin-bottom: 0;
      margin-right: 12px;
  }
  .section-count {
      display: inline-block;
      vertical-align: middle;
      padding: 6px 8px;
      background-color: #616161;
      border-radius: 3px;
      font-size: 16px;
      color: #fff;
  }

  @media only screen and (min-width: $breakpoint3) {
      .section-title {
          padding: 24px 0;
      }
      h2 {
          font-size: 40px;
      }
      .section-count {
          padding: 6px 8px;
          border-radius: 3px;
          font-size: 16px;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/SectionTitle.vue